export default class SearchHintBuilder {
  #set = new Set<string>();
  add(term: string) {
    term
      .replace(/[^\S]+/g, ' ')
      .trim()
      .toLowerCase()
      .split(' ')
      .forEach((t) => {
        this.#set.add(t);
        this.#set.add(t.replace(/^[משהוכלב]/, ''));
      });
    return this;
  }
  get() {
    return Array.from(this.#set).join(' ');
  }
}
